var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FileThumbnail',{attrs:{"fileThumbnails":_vm.adaptThumbnails(this.value)}})}
var staticRenderFns = []

export { render, staticRenderFns }